[
    {
        "value": "IELTS Academic",
        "min": 1.0,
        "max": 9.0
    },
    {
        "value": "IELTS Indicator",
        "min": 1.0,
        "max": 9.0
    },
    {
        "value": "TOEFL IBT",
        "min": 0,
        "max": 120
    },
    {
        "value": "TOEFL Home",
        "min": 0,
        "max": 120
    },
    {
        "value": "TOEFL PBT",
        "min": 310,
        "max": 677
    },
    {
        "value": "TOEFL PBT Revised",
        "min": 0,
        "max": 30
    },
    {
        "value": "PTE Academic",
        "min": 10.0,
        "max": 90
    },
    {
        "value": "Cambridge C1 Advanced",
        "min": 140,
        "max": 210
    },
    {
        "value": "Cambridge C2 Proficiency",
        "min": 160,
        "max": 230
    },
    {
        "value": "Duolingo",
        "min": 10,
        "max": 160
    }
]
